import { useDownloadPaylinksMutation } from '../../../store/modules/paylink/api';
import { toast } from '../../../util/toast';
import { DownloadPaylinksBody } from '../../../store/modules/paylink/types';

type Props = {
  merchantId: string;
};

export const useDownloadPaylinks = ({ merchantId }: Props) => {
  const [downloadPaylinks, { isLoading }] = useDownloadPaylinksMutation();

  const onDownloadPaylinks = async (body: Omit<DownloadPaylinksBody, 'merchantId'>) =>
    downloadPaylinks({ ...body, merchantId })
      .unwrap()
      .then(() => {
        toast.success(
          'Your Paylinks download is processing and will be sent to your email when it is complete.',
        );
      })
      .catch((err) => {
        toast.error('Something went wrong while downloading the Paylinks, please try again later');
        throw err;
      });

  return {
    onDownloadPaylinks,
    isLoading,
  };
};
